const numberWithCommas = (x) => {
    let number = Number(x);
    let nf = new Intl.NumberFormat('en-IN');
     let formatedNumber =  nf.format(number); // "1,234,567,890"
     return formatedNumber;
};
export default numberWithCommas;
